
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body 		= $( 'body' );
		let header 		= $( 'header' );
        let siteURL = document.location.host;
		let desktopMenuBreakpoint = parseInt(
			$(":root").css("--desktop-menu-breakpoint")
		);

        /**
         * Timeline - Remove AODA role from entries
         */
        $.each($('.timeline-item'), function () {
            $(this).removeAttr('role').removeAttr('tabindex');
        });

        /**
         * Header - add AODA attributes to the menus
         */
        $('.primary-menu-wrap > ul').attr('aria-label', 'Primary Navigation');
        $('.secondary-menu-wrap > ul').attr('aria-label', 'Secondary Navigation');

		/**
		 * Anchor Links - Open all external sites in a new tab
		 */
        $.each( $('a:not([href*="' + siteURL + '"]):not([href^="#"]):not([href^="/"])'), function (){
            $(this).attr('target', '_blank');
            $(this).append('<span class="screen-reader-text">&nbsp;(Opens in a new window)</span>');

            if ( $(this).attr('aria-label') !== undefined && ! $(this).attr('aria-label').includes("(Opens in a new window)") ) {
                let ariaLabel = $(this).attr('aria-label');
                $(this).attr('aria-label', ariaLabel + ' (Opens in a new window)');
            }
        });

		/**
		 * Form - AODA - Add accessible name to date selects
		 */
		$.each( $('.gfield_date'), function (i, date) {
			let selects = $('select', date);

			$(selects[0]).attr('aria-label', 'Select a month number.');
			$(selects[1]).attr('aria-label', 'Select a day number.');
			$(selects[2]).attr('aria-label', 'Select a year.');
		});

		/**
		 * Carousel - Set equal heights to captions on mobile
		 */
		let equalCarouselSlideHeights = function(carouselSelector){

			$(carouselSelector).each(function(){
				var items 		= $(".carousel-item", this);
				let maxHeight 	= 0;

				// Show all slides
				$.each(items, function(i, slide){

					$(this).css("height", "");
					$(".carousel-caption", this).css("height", "");

					$(slide).addClass("active");

				});

				// Get the height of the tallest caption and save it
				$.each(items, function(){

					let caption 		= $(".carousel-caption", this);
					let captionHeight 	= caption.outerHeight();

					if(captionHeight > maxHeight){
						maxHeight = captionHeight;
					}

				});

				// Apply the max height to all captions
				$.each(items, function(){

					if($(window).width() >= parseInt($(":root").css("--breakpoint-lg"))){

						$(this).css("height", maxHeight + 350);

					}else{

						$(".carousel-caption", this).css("height", maxHeight);

					}

					// Remove .active from all slides
					$(this).removeClass("active");

				});

				// Add the active class back to the first slide
				$(".carousel-inner .carousel-item:first-of-type", this).addClass("active");

			});
		};

		equalCarouselSlideHeights(".carousel-block .carousel");

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear()
		$( '#copyright-year' ).text( copyrightYear );

		/**
		 * Header - Search bar functionality
		 */
		let searchButton = $(".js-header-search-btn");
		let closeButton = $("#close-button");
		let searchBar = $("#search-container");

		// Search click
		$.each(searchButton, function () {
			$(this).on("click", function () {
				searchBar.fadeIn().addClass("show");
			});
		});

		// Close click
		closeButton.on("click", function () {
			searchBar.fadeOut().removeClass("show");
		});

		/**
		 * Navbar height
		 */
		let calculateNavbarHeight = function () {
			let navbarHeight = 0;

			$("body > header")
				.children()
				.each(function () {
					navbarHeight += $(this).outerHeight();
				});

			$("body > header").css(
				"--header-navbar-height",
				navbarHeight + "px"
			);
		};

		let resizeThrottled = false;

		$(window).on("resize", function () {
			if (!resizeThrottled) {
				calculateNavbarHeight();

				/**
				 * Disabled to prevent automatic jump to first slide on mobile scroll
				 */
				// equalCarouselSlideHeights(
				//     ".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel"
				// );

				resizeThrottled = true;

				setTimeout(function () {
					resizeThrottled = false;

					calculateNavbarHeight();
				}, 100);
			}
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100) {
			body.addClass("sticky-header");
			$("header").addClass("sticky");
		} else {
			body.removeClass("sticky-header");
			$("header").removeClass("sticky");
		}
		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$("body").addClass("sticky-header");
				$("header").addClass("sticky");
			} else {
				$("body").removeClass("sticky-header");
				$("header").removeClass("sticky");
			}
		});

		let headerHeight = $("header").height();

		if ($(window).scrollTop() > 100) {
			$("body header").addClass("sticked").css("position", "fixed");
			$("#content").css("padding-top", headerHeight);
		} else {
			$("body header").removeClass("sticked").css("position", "sticky");
			$("#content").css("padding-top", 0);
		}
		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$("body header").addClass("sticked").css("position", "fixed");
				$("#content").css("padding-top", headerHeight);
			} else {
				$("body header")
					.removeClass("sticked")
					.css("position", "sticky");
				$("#content").css("padding-top", 0);
			}
		});

		/**
		 * Mobile menu
		 */

		$("header .js-mobile-menu-toggle").on("click", function () {
			$("body").toggleClass("no-scroll");
			searchBar.fadeOut().removeClass("show");
		});

		$("#header-navbar-menu-wrapper")
			.find(
				".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu"
			)
			.each(function () {
				if ($(window).width() < desktopMenuBreakpoint) {
					$(this).addClass("mobile-menu-sub-level-panel");

					let subLevelTitleElement = $("<h6>").html(
						$(this).siblings(".nav-link").html().trim()
					);

					$(this).prepend(
						$("<li>")
							.addClass("menu-item sub-level-panel-heading")
							.append(subLevelTitleElement)
					);
				}
			});

		$("#header-navbar-menu-wrapper.navbar-collapse")
			.on("show.bs.collapse", function () {
				let headerBannerHeight = 0;

				$("body > header")
					.children()
					.each(function () {
						headerBannerHeight += $(this).outerHeight();
					});

				if (!$("body > header").hasClass("sticky")) {
					headerBannerHeight +=
						parseInt($("html").css("margin-top")) -
						$("html").scrollTop();
				}

				$(this).css(
					"--mobile-menu-height",
					$(window).outerHeight() - headerBannerHeight + "px"
				);

				$(this)
					.children(".header-navbar-menu-inner-wrap")
					.addClass("curr-level");
			})
			.on("hidden.bs.collapse", function () {
				$(this).find(".curr-level").removeClass("curr-level");

				$(this).find(".show").removeClass("show fade-in");

				$(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

				$(this).find(".js-menu-back-btn").data("depth-level", 0);
			});

		let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(
			".back-btn-wrap"
		);
		let mobileMenuBackBtn =
			mobileMenuBackBtnWrap.children(".js-menu-back-btn");

		mobileMenuBackBtn.data("depth-level", 0);

		mobileMenuBackBtn.on("click", function () {
			$(this).data("depth-level", $(this).data("depth-level") - 1);

			let currentMenuPanel = $("#header-navbar-menu-wrapper").find(
				".mobile-menu-sub-level-panel.curr-level"
			);

			currentMenuPanel
				.parent()
				.closest(".mobile-menu-sub-level-panel")
				.addClass("curr-level");

			currentMenuPanel
				.addClass("fade-out")
				.removeClass("show fade-in curr-level");

			if ($(this).data("depth-level") <= 0) {
				$("#header-navbar-menu-wrapper")
					.find(".header-navbar-menu-inner-wrap")
					.addClass("curr-level");

				$(this)
					.data("depth-level", 0)
					.parent()
					.addClass("fade-out")
					.removeClass("show fade-in");
			}
		});

		$("#header-navbar-menu-wrapper")
			.find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
			.on("click", function (evt) {
				evt.preventDefault();

				$("#header-navbar-menu-wrapper")
					.find(".curr-level")
					.removeClass("curr-level");

				$(this)
					.siblings(".mobile-menu-sub-level-panel")
					.scrollTop(0)
					.removeClass("fade-out")
					.addClass("show fade-in curr-level");

				if (window.innerWidth < 992) {
					if (mobileMenuBackBtn.data("depth-level") === 0) {
						mobileMenuBackBtnWrap
							.removeClass("fade-out")
							.addClass("show fade-in");
					} else {
						$(this)
							.siblings(".mobile-menu-sub-level-panel")
							.css(
								"top",
								$(this)
									.closest(
										".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
									)
									.scrollTop()
							);
					}
				}

				mobileMenuBackBtn.data(
					"depth-level",
					mobileMenuBackBtn.data("depth-level") + 1
				);

				return false;
			});

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialEqualHeights() {
			$('.testimonial-large-block, .testimonial-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each( items, function() {
					let caption 		= $('.card-body', this);
					let captionHeight 	= caption.outerHeight();

					if ( captionHeight > maxHeight ) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each( items, function() {
					let caption = $('.card-body', this);
					caption.css( 'height', maxHeight );

					// Remove .active from all slides
					$( this ).removeClass( 'active' );
				});

				// Add the active class back to the first slide
				$('.testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		testimonialEqualHeights();

		/**
		 * Form - Add custom checkbox element
		 */
		$( '.ginput_container_checkbox .gfield_checkbox .gchoice' ).addClass('checkbox_item').append('<div class="checkmark"></div>');
		$( '.ginput_container_radio .gfield_radio .gchoice' ).addClass('radio_item').append('<div class="radio"></div>');

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 50){
			body.addClass('sticky-header');
			$('header').addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			$('header').removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 50){
				$('body').addClass('sticky-header');
				$('header').addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				$('header').removeClass('sticky');
			}
		});

		/**
		 * Mobile Menu - Open/close functionality
		 */
		let mobileMenuContainer 	= header.find('.mobile .menus');
		let mobileMenuBtnContainer	= header.find('.mobile .menu-button-container');
		let mobileMenuOpenBtn		= header.find('.mobile .menu-button-container button.menu-button');
		let mobileMenuCloseBtn		= header.find('.mobile .menu-button-container button.close-button');
		let mobileMenuItems			= header.find('.mobile .menus .mobile-menu .main-menu-container li:not(.menu-item-has-children) a');

		$.each(mobileMenuItems, function (i, v) {
			$(v).on('click', function() {
				mobileMenuContainer.removeClass('show');
				mobileMenuBtnContainer.removeClass('open');
				body.removeClass('menu-open');
			});
		});

		// Open
		mobileMenuOpenBtn.on('click', function () {
			mobileMenuContainer.addClass('show');
			mobileMenuBtnContainer.addClass('open');
			$('html').addClass('menu-open');
			body.addClass('menu-open');
		});

		// Close
		mobileMenuCloseBtn.on('click', function () {
			mobileMenuContainer.removeClass('show');
			mobileMenuBtnContainer.removeClass('open');
			$('html').removeClass('menu-open');
			body.removeClass('menu-open');
		});

	});
})(jQuery);